module.exports = __webpack_public_path__ + "img/some_clouds.16b7a044.svg";